module.exports = __webpack_public_path__ + "img/tour-4.a97eb9dc.png";